import { render } from "./SanadList.vue?vue&type=template&id=455b114c"
import script from "./SanadList.vue?vue&type=script&lang=js"
export * from "./SanadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__